import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup } from "vue";
import _imports_0 from '@/assets/graphics/app_background.png';
const _hoisted_1 = {
  class: "relative h-full w-full flex flex-col overflow-hidden transition-[background]"
};
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center"
};
const _hoisted_3 = {
  class: "relative w-[35%] max-w-[250px] flex items-center justify-center aspect-square"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "relative h-full w-full flex overflow-hidden"
};
const _hoisted_6 = {
  class: "text-lg font-semibold"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "fixed w-full left-1/2 bottom-0 -translate-x-1/2 flex flex-col items-center gap-2 px-4 pb-4 z-50 pointer-events-none"
};
const _hoisted_10 = {
  class: "w-full flex flex-col justify-center gap-1 pointer-events-auto"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TopBar = _resolveComponent("TopBar");
  const _component_NavigationBar = _resolveComponent("NavigationBar");
  const _component_router_view = _resolveComponent("router-view");
  const _component_Autopilot = _resolveComponent("Autopilot");
  const _component_FlowDetails = _resolveComponent("FlowDetails");
  const _component_Banners = _resolveComponent("Banners");
  const _component_Drawer = _resolveComponent("Drawer");
                                                                    
  const _component_UserResourcesManager = _resolveComponent("UserResourcesManager");
  const _component_Modal = _resolveComponent("Modal");
  const _component_SlangoNews = _resolveComponent("SlangoNews");
  const _component_AppDevTools = _resolveComponent("AppDevTools");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [this.globalLoading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: _ctx.$appConfig.logotype_white || require('@/slango-multiverse/assets/slango/slango_logo_white.png'),
    alt: "",
    class: "w-[60%] animate-fade"
  }, null, 8, _hoisted_4), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "absolute h-full! w-full! border-4 rounded-full border-white/10 border-t-white animate-spin"
  }, null, -1))])])) : _createCommentVNode("", true), _createVNode(_component_TopBar, {
    hidden: this.globalLoading || !$options.showApplicationTools.topbar
  }, null, 8, ["hidden"]), !this.globalLoading ? (_openBlock(), _createElementBlock("div", _hoisted_5, [$options.showApplicationTools.navigation ? (_openBlock(), _createBlock(_component_NavigationBar, {
    key: 0,
    class: "z-50"
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["relative h-full w-full flex flex-col overflow-hidden", {
      'rounded-tl-lg': $options.showApplicationTools.topbar
    }])
  }, [_cache[6] || (_cache[6] = _createElementVNode("img", {
    src: _imports_0,
    class: "absolute inset-0 object-cover min-h-full min-w-full pointer-events-none",
    style: {
      "z-index": "-100"
    },
    alt: ""
  }, null, -1)), _createVNode(_component_router_view), this.$route.meta.autopilot ? (_openBlock(), _createBlock(_component_Autopilot, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_FlowDetails)], 2)])) : _createCommentVNode("", true), _createVNode(_component_Banners), _ctx.$state.ui.drawer ? (_openBlock(), _createBlock(_component_Drawer, {
    key: 2,
    visible: _ctx.$state.ui.drawer.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => _ctx.$state.ui.drawer.visible = $event),
    position: _ctx.$state.ui.drawer.position ?? 'right'
  }, {
    header: _withCtx(() => [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$state.ui.drawer.header ?? 'Ayuda'), 1)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "flex flex-col",
      innerHTML: _ctx.$state.ui.drawer.content
    }, null, 8, _hoisted_7)]),
    _: 1
  }, 8, ["visible", "position"])) : _createCommentVNode("", true), _ctx.$state.ui.promptModal ? (_openBlock(), _createBlock(_component_Modal, _normalizeProps(_mergeProps({
    key: 3
  }, _ctx.$state.ui.promptModal)), {
    default: _withCtx(() => [_ctx.$state.ui.promptModal.input ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_v_text_field, _mergeProps({
      variant: "outlined",
      density: "compact",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, _ctx.$state.ui.promptModal.input, {
      modelValue: _ctx.$state.ui.promptModal.input.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.$state.ui.promptModal.input.value = $event),
      placeholder: _ctx.$state.ui.promptModal.input.placeholder || 'Escribe aquí',
      "hide-details": ""
    }), null, 16, ["modelValue", "placeholder"])])) : _ctx.$state.ui.promptModal.userResourcesManager ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass({
        'w-[560px]': !_ctx.$state.ui.promptModal.userResourcesManager
      })
    }, [_createVNode(_component_UserResourcesManager, _mergeProps({
      modelValue: _ctx.$state.ui.promptModal.userResourcesManager.selected,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.$state.ui.promptModal.userResourcesManager.selected = $event),
      searchInputField: true,
      scrollLimit: false,
      shared: true,
      persistentSelection: false,
      selectable: false,
      type: "certificates"
    }, _ctx.$state.ui.promptModal.userResourcesManager, {
      onOnSelectedShared: _cache[4] || (_cache[4] = $event => _ctx.$state.ui.promptModal.userResourcesManager.hasShared = $event)
    }), null, 16, ["modelValue"])], 2)) : _createCommentVNode("", true)]),
    _: 1
  }, 16)) : _createCommentVNode("", true), _createVNode(_component_SlangoNews), this.ShowAppDevTools ? (_openBlock(), _createBlock(_component_AppDevTools, {
    key: 4
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_TransitionGroup, {
    name: "fade-from-left"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$toasts, (toast, key) => {
      return _openBlock(), _createElementBlock("div", {
        key: toast,
        class: _normalizeClass(["relative w-full max-w-[600px] flex gap-3 p-3 px-4 rounded-md", [{
          'bg-main-100 text-main-5 shadow-material': !toast.type
        }, {
          'bg-error text-main-5': toast.type === 'error'
        }, {
          'bg-second-100 shadow-material text-main-5': toast.type === 'secondary' || toast.type === 'success'
        }, {
          'w-fit!': toast.fixed
        }]])
      }, [toast.leadingIcon ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass([toast.leadingIcon, "text-lg"])
      }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [toast.title ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        innerHTML: toast.title,
        class: "text-xs font-medium"
      }, null, 8, _hoisted_11)) : _createCommentVNode("", true), toast.text ? (_openBlock(), _createElementBlock("p", {
        key: 1,
        innerHTML: toast.text,
        class: "text-xs"
      }, null, 8, _hoisted_12)) : _createCommentVNode("", true)]), toast.icon ? (_openBlock(), _createElementBlock("i", {
        key: 1,
        class: _normalizeClass([toast.icon, "text-lg"])
      }, null, 2)) : _createCommentVNode("", true), toast.close ? (_openBlock(), _createElementBlock("i", {
        key: 2,
        class: "icon-cross text-2xs absolute top-0 right-0 text-current text-2xl cursor-pointer pointer-events-auto",
        onClick: $event => delete this.$toasts[key]
      }, null, 8, _hoisted_13)) : _createCommentVNode("", true)], 2);
    }), 128))]),
    _: 1
  })])]);
}

/* Vuetify */
import { VTextField as _component_v_text_field } from "vuetify/components/VTextField"

